import React from 'react'

const CommentItem = (props) => {
  return (
    <div className="flex items-start gap-5 px-3 py-2 rounded-lg hover:bg-slate-50">
        <div className="relative">
            <img src={props.data.pic} alt={`${props.data.name} Profile Pic`} className="w-10 h-10 rounded-full" />
            <span className="absolute bottom-0 right-0 p-0.5 leading-none bg-white rounded-full">{props.data.emoji}</span>
        </div>
        <div className="flex flex-col flex-1">
            <div className="flex items-center justify-between">
                <div className="font-semibold">{props.data.name}</div>
                <div className="text-xs text-slate-400">
                    {props.data.date_time}
                </div>
            </div>
            <p>{props.data.text}</p>
        </div>
    </div>
  )
}

export default CommentItem